import { useState } from "react";
import { FaTrashAlt } from "react-icons/fa";
import { MdCancel } from "react-icons/md";
export const InfoBlock = ({ title, value, children, headerExtension }) => {
    return (
        <div className="info-block-wrapper">
            <div className="info-block-header">
                <p className="info-block-title">{title}</p>
                {headerExtension}
            </div>
            {value && <p className="info-block-value">{value}</p>}
            {children}
        </div>
    );
};

export const Chip = ({
    text,
    status,
    icon,
    onClick,
    disableClicking,
    deletable,
    deleteType,
    onDelete,
    nanoData = {},
}) => {
    const colorCoverter = {
        Normal: "#38bf8b",
        Alert: "#ffca3a",
        Offline: "#ff595e",
        Neutral: "gray",
        Icon: "transparent",
        null: "#ff595e",
        Null: "#ff595e",
        Half: "linear-gradient(to right, rgb(255, 202, 58) 0% 50%, rgb(255, 89, 94) 50% 100%)",
    };
    return (
        <div
            className={`chip ${disableClicking ? "" : "clickable"}`}
            style={{
                backgroundColor:
                    Object.keys(nanoData).length > 0 && nanoData.status === null ? "rgb(235, 235, 235)" : "",
            }}
            onClick={(e) => {
                if (onClick && !disableClicking) {
                    onClick(e);
                }
            }}
        >
            {status !== "None" && (
                <div className="chip-circle" style={{ background: colorCoverter[status] }}>
                    {status === "Icon" && icon}
                </div>
            )}
            <p className="chip-text">{text}</p>
            {deletable && (
                <div className="chip-circle chip-delete" onClick={onDelete}>
                    {(!deleteType || deleteType === "delete") && <FaTrashAlt />}
                    {deleteType === "cancel" && <MdCancel />}
                </div>
            )}
        </div>
    );
};

export const Card = ({ header, children, forwardRef }) => {
    return (
        <div className="card-wrapper" ref={forwardRef}>
            {header && <h3 className="card-header">{header}</h3>}
            <div className={`card`}>{children}</div>
        </div>
    );
};

export const RectBtn = ({ children, onClick, warning, disable }) => {
    const [loading, setLoading] = useState(false);
    return (
        <button
            className={`rect-btn ${warning && "warning"} ${(disable || loading) && "disable"}`}
            onClick={async (e) => {
                if (!disable && !loading) {
                    setLoading(true);
                    await onClick(e);
                    setLoading(false);
                }
            }}
        >
            {children}
        </button>
    );
};
